module.exports = __webpack_public_path__ + "static/media/smile-wink.aa1e6fa3.svg";